import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Typography, Box } from '@mui/material';
import Step from '../components/Step';

function GetDeleted() {
  return (
    <>
      <NavBar isSimpleMode={true} />

      {/* HOW TO DELETE SECTION */}
      <Box
        id="delete-my-record"
        sx={{
          py: { xs: '1.5rem', md: '10rem' },
          background: "black"
        }}>

        <Box sx={{
          m: { xs: '2rem', md: '0rem' },
        }}>

          <Typography
            sx={{
              color: "white",
              fontWeight: 700,
              margin: "4rem auto",
              fontSize: { xs: '3.4rem', sm: '4.6rem' },
              lineHeight: { xs: '4rem', sm: '5.7rem' },
              textAlign: "center"
            }}
          >
            How to delete my data on SplitEV?
          </Typography>

          <Box
            component="ul"
            sx={{
              listStyle: 'none',
              margin: "auto",
              my: "4rem auto",
              maxWidth: "55ch",
              width: "95%",
              display: "flex",
              flexDirection: "column",
              gap: "2rem"
            }}
          >
            <Step
              position="1"
              title="Send us an Email ✉️"
            >
              Send us an email with your account delete request:
              <Box
                component='a'
                href="mailto:charge@splitev.co"
                sx={{
                  color: "#fff",
                  fontSize: "1.5rem",
                  fontWeight: 400,
                  textAlign: "left",
                  textDecorationLine: "underline",
                  width: 'fit-content',
                  display: 'inline',
                  ml: "0.5rem"
                }}
              >
                charge@splitev.co
              </Box>
            </Step>


            <Step
              position="2"
              title="Tell us your story 😢"
              text="⁠⁠Tell us the reason you want to delete the account in the email. It's just so hard for us to see you go."
            />

            <Step
              position="3"
              title="All your data will be deleted 🗑️"
              text="We will delete all your data in the next 24 hours. 
              We will send you a confirmation email after the deletion of your account."
            />
          </Box>

        </Box>
      </Box >



      <Footer />
    </>
  );
}

export default GetDeleted;

